define('SageDotCom/DataLayer/Events/findPartnerSearch',["jquery", "SageDotCom/DataLayer/Events/eventBase"], function ($, EventBase) {

    function FindPartnerSearchEvent() {
        EventBase.call(this); // inherit eventBase
        this.name = "find_a_partner"; // overwrite name
    }

    FindPartnerSearchEvent.prototype = Object.create(EventBase.prototype);

    FindPartnerSearchEvent.prototype.GenerateEventMetadata = function GenerateEventMetadata(scope, extendData) {
        var eventData = {
            'event_name': this.getName(),
            'event_non-int': "0",
            'event_category': "component",
            'event_action': this.getName()
        };

        if (scope) {
            var lbl = $("input[type='submit'], button[type='submit']", scope).text();

            var location = this.getLocation(scope);
            var partner = "";
            var distance = "";
            if (extendData) {
                lbl = extendData.contactoption || extendData.label || lbl;
                distance = extendData.partnername || extendData.distance + " " + extendData.unit;
                partner = extendData.partner || extendData.partnerType;
            }
            eventData = $.extend(eventData, {
                'event_label': this.stripHtml(lbl.trim()), // strip any html,
                'event_name_level_1': this.getId(scope),
                'event_name_level_2': distance,
                'event_name_level_3': partner || "",
                'event_name_level_4': location
            });
        }

        return eventData;
    };

    return new FindPartnerSearchEvent();
});
